import { configureStore } from '@reduxjs/toolkit';
import brandReducer from './slices/brandSlice';
import brandsReducer from './slices/brandsSlice';
import authReducer from './slices/authSlice';
import recommendationsReducer from './slices/recommendationsSlice';

export const store = configureStore({
  reducer: {
    brand: brandReducer,
    brands: brandsReducer,
    auth: authReducer,
    recommendations: recommendationsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
